export default Object.freeze({
    LOGIN:{
        name: 'Login',
        route: '/login'
    },
    DASHBOARD:{
        name: 'Dashboard',
        route: '/home'
    },
    LISTING:{
        name: 'Listing',
        route: '/list'
    }, 
    PROFILE:{
        name: 'Profile',
        route: '/me'
    },
})